import configureStore from './store';

export const store = configureStore();
export { default as configureStore } from './store';
